import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import GlobalContext from './GlobalContext';
import globalStandardLogoAndStyles from './globalStandardLogoAndStyles';

import LoginAPI from '../services/API/others/LoginAPI';

export default function GlobalProvider({ children }) {
  const [isLoading, setIsLoading] = useState(false);
  const [companyData, setCompanyData] = useState(globalStandardLogoAndStyles);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const retrieveCompanyData = () => {
      LoginAPI.getLoginCompanyData()
        .then((response) => {
          if (response?.data.message) throw response?.data;
          setCompanyData(response?.data);
        })
        .catch((error) => {
          console.error(error.message);
        });
    };

    if (LoginAPI.verifyDomain()) {
      retrieveCompanyData();
    }
  }, []);

  const context = useMemo(
    () => ({
      isLoading,
      setIsLoading,
      companyData,
      setCompanyData,
      userData,
      setUserData,
    }),
    [isLoading, companyData, userData]
  );

  return (
    <GlobalContext.Provider value={context}>{children}</GlobalContext.Provider>
  );
}

GlobalProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
